<template>
    <div id="create-telnyx-channel">
        <a-form>
            <div class="form-section">
                <h4>Kanal Bilgileri</h4>
                <div class="input-wrapper">
                    <label>Kanal Adı</label>
                    <a-form-item
                        :validate-status="getErrorStatus('name')"
                        :help="getErrorMessage('name')"
                    >
                        <a-input
                            v-model="form.name"
                            placeholder="Örn: Satış Hattı"
                            name="name"
                        />
                    </a-form-item>
                </div>

                <div class="input-wrapper">
                    <label>Kullanıcı Seçimi</label>
                    <div v-if="!selectedUser" class="user-selection">
                        <a-button @click="showUserPicker = true" type="dashed" icon="user" block>
                            Kullanıcı Seç (Varsayılan: {{ user.name }})
                        </a-button>
                    </div>
                    <div v-else class="selected-user">
                        <div class="user-info">
                            <a-avatar :size="32" style="margin-right: 12px">
                                {{ getUserInitials(selectedUser) }}
                            </a-avatar>
                            <div class="user-details">
                                <div class="user-name">{{ selectedUser.name }}</div>
                                <div class="user-email">{{ selectedUser.email }}</div>
                            </div>
                            <a-button type="link" icon="close" @click="selectedUser = null" style="margin-left: auto">
                                Kaldır
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-section-row">
                <div class="form-section-half">
                    <h4>Telnyx Hesap Bilgileri</h4>
                    <div class="input-wrapper">
                        <label>Username *</label>
                        <a-form-item
                            :validate-status="getErrorStatus('username')"
                            :help="getErrorMessage('username')"
                        >
                            <a-input
                                v-model="form.username"
                                placeholder="Telnyx kullanıcı adınız"
                                name="telnyx-username"
                                autocomplete="off"
                            />
                        </a-form-item>
                    </div>

                    <div class="input-wrapper">
                        <label>Password *</label>
                        <a-form-item
                            :validate-status="getErrorStatus('password')"
                            :help="getErrorMessage('password')"
                        >
                            <a-input-password
                                v-model="form.password"
                                placeholder="Telnyx şifreniz"
                                name="telnyx-password"
                                autocomplete="new-password"
                            />
                        </a-form-item>
                    </div>

                    <div class="input-wrapper">
                        <label>API Key *</label>
                        <a-form-item
                            :validate-status="getErrorStatus('apiKey')"
                            :help="getErrorMessage('apiKey')"
                        >
                            <a-input-password
                                v-model="form.apiKey"
                                placeholder="Telnyx API anahtarınız"
                                name="telnyx-apikey"
                                autocomplete="off"
                            />
                        </a-form-item>
                    </div>

                    <div class="input-wrapper">
                        <label>Caller Phone Number *</label>
                        <a-form-item
                            :validate-status="getErrorStatus('callerPhoneNumber')"
                            :help="getErrorMessage('callerPhoneNumber')"
                        >
                            <a-input
                                v-model="form.callerPhoneNumber"
                                placeholder="Örn: +18445420900"
                                name="callerPhoneNumber"
                                autocomplete="off"
                            />
                        </a-form-item>
                    </div>
                </div>

                <div class="form-section-half">
                    <h4>Bağlantı Ayarları</h4>
                    <div class="input-wrapper">
                        <label>Domain *</label>
                        <a-form-item
                            :validate-status="getErrorStatus('domain')"
                            :help="getErrorMessage('domain')"
                        >
                            <a-input
                                v-model="form.domain"
                                placeholder="sip.telnyx.com"
                                name="domain"
                                autocomplete="off"
                            />
                        </a-form-item>
                    </div>

                    <div class="input-wrapper">
                        <label>WebSocket Server *</label>
                        <a-form-item
                            :validate-status="getErrorStatus('websocketServer')"
                            :help="getErrorMessage('websocketServer')"
                        >
                            <a-input
                                v-model="form.websocketServer"
                                placeholder="wss://sip.telnyx.com:7443"
                                name="websocketServer"
                                autocomplete="off"
                            />
                        </a-form-item>
                    </div>
                </div>
            </div>

            <div class="form-actions">
                <a-button @click="$emit('cancel')" style="margin-right: 8px"> İptal </a-button>
                <a-button type="primary" @click="handleSubmit" :loading="creating"> Kanal Oluştur </a-button>
            </div>
        </a-form>

        <!-- User Picker Modal -->
        <a-modal
            v-model="showUserPicker"
            title="Kullanıcı Seç"
            :footer="null"
            width="800px"
            :bodyStyle="{ padding: '15px' }"
        >
            <UserPicker @user-selected="onUserSelected" />
        </a-modal>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import UserPicker from "../../Tables/detail/pickers/UserPicker.vue";
import log2 from "../../../../utils/log2";

const log = log2("CreateTelnyxChannel");

export default Vue.extend({
    name: "CreateTelnyxChannel",
    components: {
        UserPicker,
    },
    data() {
        return {
            form: {
                name: "Telnyx Kanalı",
                username: "",
                password: "",
                apiKey: "",
                callerPhoneNumber: "",
                domain: "sip.telnyx.com",
                websocketServer: "wss://sip.telnyx.com:7443",
            },
            creating: false,
            showUserPicker: false,
            selectedUser: null,
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            listChannels: "channel/listChannels",
            fetchUsers: "user/getUsers",
        }),
        getErrorStatus(fieldName) {
            if (!this.submitClicked) return "";
            
            if (fieldName === "name") {
                return this.form.name.length < 1 ? "error" : "";
            }
            if (fieldName === "username") {
                return this.form.username.length < 1 ? "error" : "";
            }
            if (fieldName === "password") {
                return this.form.password.length < 1 ? "error" : "";
            }
            if (fieldName === "apiKey") {
                return this.form.apiKey.length < 10 ? "error" : "";
            }
            if (fieldName === "callerPhoneNumber") {
                const phoneRegex = /^\+[1-9]\d{1,14}$/;
                return this.form.callerPhoneNumber.length < 1 || !phoneRegex.test(this.form.callerPhoneNumber) ? "error" : "";
            }
            if (fieldName === "domain") {
                return this.form.domain.length < 1 ? "error" : "";
            }
            if (fieldName === "websocketServer") {
                const urlRegex = /^wss?:\/\/.+/;
                return this.form.websocketServer.length < 1 || !urlRegex.test(this.form.websocketServer) ? "error" : "";
            }
            return "";
        },
        getErrorMessage(fieldName) {
            if (!this.submitClicked) return "";
            
            if (fieldName === "name") {
                return this.form.name.length < 1 ? "Kanal adı zorunludur" : "";
            }
            if (fieldName === "username") {
                return this.form.username.length < 1 ? "Username zorunludur" : "";
            }
            if (fieldName === "password") {
                return this.form.password.length < 1 ? "Password zorunludur" : "";
            }
            if (fieldName === "apiKey") {
                if (this.form.apiKey.length < 1) {
                    return "API Key zorunludur";
                }
                if (this.form.apiKey.length < 10) {
                    return "API Key en az 10 karakter olmalıdır";
                }
                return "";
            }
            if (fieldName === "callerPhoneNumber") {
                if (this.form.callerPhoneNumber.length < 1) {
                    return "Telefon numarası zorunludur";
                }
                const phoneRegex = /^\+[1-9]\d{1,14}$/;
                if (!phoneRegex.test(this.form.callerPhoneNumber)) {
                    return "Geçerli bir telefon numarası girin (E.164 formatında)";
                }
                return "";
            }
            if (fieldName === "domain") {
                return this.form.domain.length < 1 ? "Domain zorunludur" : "";
            }
            if (fieldName === "websocketServer") {
                if (this.form.websocketServer.length < 1) {
                    return "WebSocket Server zorunludur";
                }
                const urlRegex = /^wss?:\/\/.+/;
                if (!urlRegex.test(this.form.websocketServer)) {
                    return "Geçerli bir WebSocket URL'si girin";
                }
                return "";
            }
            return "";
        },
        validateForm() {
            this.submitClicked = true;
            
            // Validate required fields
            if (!this.form.name || !this.form.username || !this.form.password || !this.form.apiKey ||
                !this.form.callerPhoneNumber || !this.form.domain || !this.form.websocketServer) {
                this.$message.error("Tüm zorunlu alanları doldurun");
                return false;
            }

            // Validate API Key length
            if (this.form.apiKey.length < 10) {
                this.$message.error("API Key en az 10 karakter olmalıdır");
                return false;
            }

            // Validate phone number format
            const phoneRegex = /^\+[1-9]\d{1,14}$/;
            if (!phoneRegex.test(this.form.callerPhoneNumber)) {
                this.$message.error("Telefon numarası E.164 formatında olmalıdır (örn: +18445420900)");
                return false;
            }

            // Validate WebSocket URL format
            const urlRegex = /^wss?:\/\/.+/;
            if (!urlRegex.test(this.form.websocketServer)) {
                this.$message.error("WebSocket Server geçerli bir URL olmalıdır (örn: wss://sip.telnyx.com:7443)");
                return false;
            }

            return true;
        },
        async handleSubmit() {
            if (!this.validateForm()) {
                return;
            }

            await this.createTelnyxChannel();
        },
        async createTelnyxChannel() {
            try {
                this.creating = true;

                // Eğer kullanıcı seçilmediyse, mevcut kullanıcıyı kullan
                const userId = this.selectedUser ? this.selectedUser._id : this.user._id;

                const payload = {
                    username: this.form.username,
                    password: this.form.password,
                    apiKey: this.form.apiKey,
                    callerPhoneNumber: this.form.callerPhoneNumber.startsWith("+")
                        ? this.form.callerPhoneNumber
                        : "+" + this.form.callerPhoneNumber,
                    domain: this.form.domain,
                    websocketServer: this.form.websocketServer,
                    userId: userId,
                };

                await this.createChannel({
                    type: "webphone-telnyx",
                    name: this.form.name,
                    payload: payload,
                    visibility: {
                        users: [],
                        departments: [],
                    },
                    forward: {
                        department: null,
                        story: null,
                        mode: "live",
                        hybrid: {
                            department: null,
                        },
                        chatbotRespondToGroupChats: false,
                    },
                });

                this.$message.success("Telnyx kanalı başarıyla oluşturuldu");
                this.listChannels();
                this.$emit("ok");
            } catch (error) {
                console.error("Telnyx kanal oluşturma hatası:", error);
                this.$message.error("Kanal oluşturulurken hata oluştu: " + (error.message || error));
            } finally {
                this.creating = false;
            }
        },
        onUserSelected(user) {
            console.log("onUserSelected user", user);
            this.selectedUser = user;
            this.showUserPicker = false;
        },
        getUserInitials(user) {
            if (!user || !user.name) return "?";
            return user.name
                .split(" ")
                .map((n) => n[0])
                .join("")
                .toUpperCase()
                .substring(0, 2);
        },
    },
    async mounted() {
        // Kullanıcıları yükle
        await this.fetchUsers({
            perPage: 1000,
            page: 1,
            query: "",
            updateStore: true,
        });
        
        // Varsayılan olarak mevcut kullanıcıyı seç
        if (this.user) {
            this.onUserSelected(this.user);
        }
    },
});
</script>

<style lang="scss" scoped>
#create-telnyx-channel {
    min-height: 400px;
    flex-direction: column;

    .form-section {
        //margin-bottom: 32px;
        padding: 5px;
        border-bottom: 1px solid #f0f0f0;

        &:last-of-type {
            border-bottom: none;
            margin-bottom: 0;
        }

        h4 {
            color: #1890ff;
            font-weight: 600;
            margin-bottom: 16px;
            font-size: 16px;
        }

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
            margin-bottom: 5px;

            label {
                font-weight: 500;
                margin-bottom: 5px;
            }
        }
    }

    .form-section-row {
        display: flex;
        gap: 20px;
        padding: 5px;
        border-bottom: 1px solid #f0f0f0;

        &:last-of-type {
            border-bottom: none;
            margin-bottom: 0;
        }

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 10px;
        }
    }

    .form-section-half {
        flex: 1;
        padding: 15px;
        background: #fafafa;
        border-radius: 8px;

        h4 {
            color: #1890ff;
            font-weight: 600;
            margin-bottom: 16px;
            font-size: 16px;
            margin-top: 0;
        }

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            label {
                font-weight: 500;
                margin-bottom: 5px;
            }
        }
    }

    .user-selection {
        .ant-btn {
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            font-size: 14px;
        }
    }

    .selected-user {
        .user-info {
            padding: 12px;
            background: #f0f9ff;
            border: 1px solid #0ea5e9;
            border-radius: 8px;
            display: flex;
            align-items: center;

            .user-details {
                .user-name {
                    font-weight: 500;
                    color: #1c1c1e;
                    font-size: 14px;
                }

                .user-email {
                    font-size: 12px;
                    color: #666;
                }
            }
        }
    }

    .form-actions {
        display: flex;
        justify-content: flex-end;
        padding: 10px 20px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>
